const NAV_SELECTOR = "[data-scrollspy]";

const links = [];
const targets = [];
let observer;

function mapTarget(link) {
  if (links.includes(link)) {
    return null;
  }

  const container = this;
  const target = document.querySelector(link.getAttribute("href"));

  if (target) {
    links.push({
      closest: container.contains(link) ? container : null,
      left: link.getBoundingClientRect().left,
      parentNode: link.parentNode
    });
    targets.push(target);
  }

  return target;
}

function onIntersectionEntry({ isIntersecting, target }) {
  const { closest, left, parentNode } = links[targets.indexOf(target)];

  if (isIntersecting) {
    parentNode.classList.add("active");
    if (closest) {
      closest.scrollLeft += left;
    }
  } else {
    parentNode.classList.remove("active");
  }
}

function onIntersection(entries) {
  entries.forEach(onIntersectionEntry);
}

function observeTarget(link, target) {
  if (!target) {
    return;
  }

  observer = observer || new IntersectionObserver(
    onIntersection.bind(link),
    {
      root: null,
      rootMargin: "-10px 0px -90% 0px",
      threshold: 0
    }
  );

  observer.observe(target);
}

function scrollSpy(container = document.querySelector(NAV_SELECTOR)) {
  if (!container) {
    return;
  }

  // container.querySelectorAll("a").forEach(observeTargetOld);
  container.querySelectorAll("a").forEach(link => {
    const target = mapTarget.call(container, link);

    observeTarget(link, target);
  });
}

export default scrollSpy;



// WEBPACK FOOTER //
// ./components/scrollspy/scrollspy.js